module.exports = __webpack_public_path__ + "img/P15b_19920085-1415.8b090aaf.jpg";